export default class KV {
    constructor() {
        this.init()
    }

    init() {
        setTimeout(this.inAnimation.bind(this), 500)
    }

    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1)) // 0 から i のランダムなインデックス
            ;[array[i], array[j]] = [array[j], array[i]] // 要素を入れ替えます
        }
    }

    inAnimation() {
        const elements = [...document.querySelectorAll('.js-kvbg_item')]
        this.shuffleArray(elements)

        elements.forEach((elm, index) => {
            const randDelay = Math.random() * 0.8
    
            setTimeout(() => {
                elm.classList.add('-itemin')
            }, 1000 * randDelay)
        })
    }
}
